import { ApplicationInsights } from "@microsoft/applicationinsights-web";
 
 
const AppInsight=new ApplicationInsights({
    config:{
         instrumentationKey:process.env.REACT_APP_INSTRUMENTATION_KEY_APPINSIGHTS,
         enableAutoRouteTracking:true,
 
    },
});
AppInsight.loadAppInsights();
 
 
export default AppInsight;